var map = {
	"./Clear.jpg": 11,
	"./Clouds.jpg": 12,
	"./Fog.jpg": 13,
	"./Snow.jpg": 14,
	"./Thunderstorm.jpg": 15,
	"./cold.jpg": 16,
	"./rainy2.jpg": 17,
	"./sunny1.jpg": 18,
	"./warm.jpg": 19
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10;